<div
  fxLayout="row"
  fxLayoutAlign="start center"
  [ngClass]="menuOptions?.length ? 'c-feedItemTitle' : 'u-padding-16'"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
    <mat-icon *ngIf="iconName" class="u-marginRight-8">
      {{ iconName }}
    </mat-icon>
    <a [routerLink]="link" (click)="itemClicked.emit()" class="u-marginRight-8">
      <b i18n="@@feedItem.title">{title, select, other {{{ title }}}}</b>
    </a>
    <div *ngIf="feedItem.private">
      <div
        class="u-borderRadius--4px bg-color-blue-200--20 u-paddingLeft-8 u-paddingRight-8"
        [ngStyle]="{
          paddingTop: '4px',
          paddingBottom: '4px',
          display: 'inline-block',
        }"
      >
        <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
          <p
            class="color-blue text-overline u-textUppercase"
            i18n="@@global.privateEvent"
          >
            Private event
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="menuOptions?.length && showMenuOptions" fxFlex="none">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-container *ngFor="let option of menuOptions">
        <button mat-menu-item (click)="option.action(feedItem)">
          <span i18n="@@feedItem.menuItem">{option.label, select,
            other {{{ option.label }}}
          }</span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>
